import { useEffect, useRef } from "react";

// A subcategory belongs to one category, so it cannot outlive a change of category.
export const useSubCategoryResetOnCategoryChange = (
  categoryValue: string | undefined,
  setValue: (name: "subCategory", value: null) => void,
) => {
  const prevCategoryValue = useRef(categoryValue);

  useEffect(() => {
    if (categoryValue !== prevCategoryValue.current) {
      setValue("subCategory", null);
      prevCategoryValue.current = categoryValue;
    }
  }, [categoryValue, setValue]);
};
